
export class lovReturnBO {
    lovId: string;
    error: string;
}
export class lovDropdown {
    label: string;
    value: string;
}
export class sortingObj {
    itemperpage: number = 20;
    currentPgNo: number = 1;
    shortcolumn: string = "LovCode";
    shortType: string = 'asc';
    column: string = "LovCode";
    text: string = ""
}
export class WhereCondition {
    field: string = "LovCode";
    value: string = "";
    operator: string = "startswith";
    orderNo: number = 1;
    predicate: string = "and";
    type: string = "string";
    matchCase: boolean = false;
}
export class GetListBO {
    orderColumn: string = "LovCode";
    orderType: string = "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    listId: string;
    field: string = "LovCode";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    // agencyID: string;
    type: string = "string";

}
export class functionpermission {
    lovcreate: boolean = true;
    lovdelete: boolean = true;
    lovupdate: boolean = true;

}

export class columnWidth {
    column: string = "";
    width: number = 0;
}

export class ColumnChangeBO {
    id: string;
    userid: string = "00000000-0000-0000-0000-000000000000";
    agencyId: string = "00000000-0000-0000-0000-000000000000";
    column: string;
}

export class saveLovBO {
    id: string;
    lovCode: string;
    lovName: string;
    lovValue: string;
    listId: string;
    orderby: number;
}

export class GetLovBO {
    role: string;
    user: string | null;
    searchColumn: string;
    searchText: string;
    userId: string | null;
    agencyId: string | null;
    clientId: string;
    locationId: string | null;
    currentpageno: number = 1;
    orderType: string = "asc";
    pageitem: number = 10;
    orderColumn: string = "LovCode";
    type: string = "string";
    field: string = "LovCode";
    value: string = "";
    listId: string | null;
    operator: string = "startswith";
    matchCase: boolean = false;
}